'use client'

import { Fragment } from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { Grid, Container, Typography, Divider } from '@mui/material'

// Types
import type { FooterProps } from '@/types/components/organisms/footer'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Fonts


// Components
const FooterBoxMolecule = dynamic(() => import('@/components/molecules/footer-items/box'))
const FooterColumnMolecule = dynamic(() => import('@/components/molecules/footer-items/column'))

const FooterOrganism = (props: FooterProps) => {
	// Props
	const { lng, links } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Fragment>
			<Grid
				mb={-3}
				container
				justifyContent="center"
				sx={{
					'& img': {
						width: 1,
						height: 'auto'
					}
				}}
			>
				<Image src="/images/parts/footer.svg" width={1440} height={400} alt={t('common:title.footer')} />
			</Grid>

			<Grid container py={3} size={12} bgcolor="#c69c6d">
				<Container>
					<Grid container spacing={3}>
						{links.map((menus, index) => {
							if (index + 1 == links.length)
								return (
									<Grid key={index} size={{ xs: 12, sm: 4, md: 2 }} sx={{ order: { xs: -1, md: 'inherit' } }}>
										<FooterBoxMolecule items={menus.items} />
									</Grid>
								)
							else
								return (
									<Grid key={index} size={{ xs: 12, sm: 4, md: 2 }}>
										<FooterColumnMolecule title={menus.title} items={menus.items} />
									</Grid>
								)
						})}
					</Grid>
				</Container>
			</Grid>

			<Grid container bgcolor="#c69c6d">
				<Divider
					flexItem
					sx={{
						opacity: 0.85,
						width: 1,
						bgcolor: 'common.white'
					}}
				/>

				<Grid size={12} py={2}>
					<Typography component="p" fontSize={{ xs: 12, md: 14 }} fontWeight={400} textAlign="center" color="common.black">
						© {t('common:description.copyright', { year: new Date().getFullYear() })}
					</Typography>
				</Grid>
			</Grid>
		</Fragment>
	)
}

export default FooterOrganism
